/**
 *
 * 11994 Request constants
 *
 */

export const ON_IMPORT_CARGO = '2970853252000';
export const ON_EXPORT_CARGO = '2971239563000';
export const ON_MOVEMENT_TMC = '3813744635000';
